/** A sortable column heading, carrying its own sort direction and `aria-sort`. */
import { ArrowDown, ArrowUp } from 'lucide-react';

import type { BookingSort, BookingSortDir } from '../../../api/bookingsList';
import { TH } from '../bookingListTableStyle';

export default function BookingSortHeader({
  field,
  label,
  sort,
  dir,
  onSort,
  align = 'left',
}: {
  field: BookingSort;
  label: string;
  sort: BookingSort;
  dir: BookingSortDir;
  onSort: (f: BookingSort) => void;
  align?: 'left' | 'right';
}) {
  const active = sort === field;
  return (
    <th
      className={`${TH} ${align === 'right' ? 'text-right' : ''}`}
      aria-sort={active ? (dir === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <button
        type="button"
        onClick={() => onSort(field)}
        className={`inline-flex items-center gap-1 hover:text-bark-900 dark:hover:text-stone-200 ${
          active ? 'text-bark-900 dark:text-stone-200' : ''
        }`}
      >
        {label}
        {active && (dir === 'asc' ? <ArrowUp size={12} /> : <ArrowDown size={12} />)}
      </button>
    </th>
  );
}
